<template>
    <div class="sidebar">
        <div class="bird"></div>
        <div class="function">
            <a class="kf" target="_blank" href="http://www.jk.cn/im-cs-m/#/nav?entranceId=61976780206">
                <i></i>
                <div class="hover-box kf-hover">
                    <b class="arr"></b>
                    <b class="icon"></b>
                    <div class="txt1">点击在线咨询</div>
                    <div class="txt2">快速高效与您沟通</div>
                </div>
            </a>
            <a class="hot-line">
                <i></i>
                <div class="hover-box line-hover">
                    <b class="arr"></b>
                    <b class="icon"></b>
                    <div class="txt1">全国服务热线</div>
                    <div class="txt2">400-931-6788</div>
                </div>
            </a>
            <a class="ewm">
                <i></i>
                <div class="hover-box ewm-hover">
                    <b class="arr"></b>
                    <img :src="ewm" alt="">
                    <div class="txt2">医疗服务</div>
                </div>
            </a>
            <a class="feedback" target="_blank" :href="feedBack">
                <i></i>
                <div class="hover-box feedback-hover">
                    <b class="arr"></b>
                    <b class="icon"></b>
                    <div class="txt1">点击反馈问题</div>
                    <div class="txt2">专人为您解决问题</div>
                </div>
            </a>
            <a class="top-scroll" @click="scrollTop()">
                <i></i>
            </a>
        </div>
    </div>
</template>
<script>
    import kf_dialog from '../../../static/js/utils/kf_dialog.js'
    import url from '../../../config/url';
    export default {
        data() {
            return {
                feedBack: url.commonRoot + "/sso/feedback?feedbackSource=6",
                ewm:  url.static + "/img/wx-ewm.jpg"
            }
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            open_kf_dialog(){
                kf_dialog.webTalkOnline(1000,618)
            },
            scrollTop(){
                $("html, body").stop().animate({ scrollTop: 0 }, 400);
            }
        }
    }
</script>
<style scoped lang="scss">
.sidebar{
    position: fixed;
    top:40%;
    margin-top: -120px;
    right: 0;
    z-index: 9;
    .bird{
        background: url("../../../static/img/index_mixd.png") no-repeat -23px 0;
        width: 58px;
        height: 67px;
        position: absolute;
        right: 0;
        z-index: 2;
    }
    .function{
        position: absolute;
        z-index: 3;
        margin-top: -15px;
        top: 75px;
        right: 0;
        a{
            position: relative;
            display: block;
            width: 48px;
            height: 48px;
            background: #fff;
            border-bottom: #efefef 1px solid;
            text-align: center;
            line-height: 48px;
            &:last-of-type{
                border-bottom: none;
            }
            i{
                display: inline-block;
                background: url("../../../static/img/index_mixd.png") no-repeat;
            }
            &:hover{
                background:#f97115;
            }
            &.kf{
                i{
                    width: 23px;
                    height: 22px;
                    margin-top: 12px;
                    background-position: 0 0;
                }
                &:hover{
                    i{
                        background-position: 0 -22px;
                    }
                }
            }
            &.hot-line{
                i{
                    margin-top: 12px;
                    width: 21px;
                    height: 23px;
                    background-position: 0 -44px;
                }
                &:hover{
                    i{
                        background-position: 0 -67px;
                    }
                }
            }
            &.ewm{
                i{
                    margin-top: 12px;
                    width: 21px;
                    height: 21px;
                    background-position: 0 -90px;
                }
                &:hover{
                    i{
                        background-position: 0 -111px;
                    }
                }
            }
            &.feedback{
                i{
                    width: 20px;
                    height: 24px;
                    margin-top: 10px;
                    background-position: -57px -111px;
                }
                &:hover{
                    i{
                        background-position: -57px -88px;
                    }
                }
            }
            &.top-scroll{
                i{
                    margin-top: 14px;
                    width: 21px;
                    height: 21px;
                    background-position:-24px -111px;
                }
                &:hover{
                    i{
                        background-position: -24px -91px;
                    }
                }
            }
            .hover-box{
                display: none;
            }
            &.kf{
                .hover-box{
                    top:0;
                }
                .arr{
                    top: 18px;
                }
                .icon{
                    width: 54px;
                    height: 51px;
                    margin: 22px auto 0;
                    background: url("./../../../static/img/hover_icon.png") 0 0 no-repeat;
                }
                .txt1{
                    margin-top: 15px;
                }
            }
            &.hot-line{
                .hover-box{
                    top:-48px;
                }
                .arr{
                    top: 65px;
                }
                .icon{
                    width: 49px;
                    height: 49px;
                    background: url("./../../../static/img/hover_icon.png")  0 -51px no-repeat;
                    margin: 22px auto 0;
                }
                .txt1{
                    margin-top: 17px;
                }
            }
            &.ewm{
                .hover-box{
                    top:-95px;
                    img{
                        display: block;
                        width: 98px;
                        height: 98px;
                        margin: 10px auto;
                    }
                }
                .arr{
                    top: 113px;
                }
            }
            &.feedback{
                .hover-box{
                    top:-97px;
                }
                .arr{
                    top: 114px;
                }
                .icon{
                    width: 54px;
                    height: 51px;
                    margin: 22px auto 0;
                    background: url("./../../../static/img/hover_icon.png") 0 -108px no-repeat;
                }
                .txt1{
                    margin-top: 15px;
                }
            }
            .hover-box{
                position: absolute;
                width: 118px;
                height: 144px;
                background: #fff;
                border: 1px solid #ff8e42;
                left: -118px;
                .icon{
                    display: block;
                }
                .txt1{
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                    line-height: 18px;
                    font-weight: 600;
                }
                .txt2{
                    text-align: center;
                    font-size: 12px;
                    color: #333;
                    line-height: 18px;
                    margin-top: 5px;
                }
                .arr{
                    position: absolute;
                    display: block;
                    width: 10px;
                    height: 10px;
                    right: -4px;
                    background: #fff;
                    right: -4px;
                    transform:rotate(-135deg);
                    -ms-transform:rotate(-135deg); 	/* IE 9 */
                    -moz-transform:rotate(-135deg); 	/* Firefox */
                    -webkit-transform:rotate(-135deg); /* Safari 和 Chrome */
                    -o-transform:rotate(-135deg);
                }
            }
            &:hover{
                .hover-box{
                    display: block;
                }
            }




        }
    }



}
</style>


// WEBPACK FOOTER //
// src/components/Common/sideBar.vue